<div class="dashboard-container">

  <div class="row">
    <div class="col">
      <!-- Card Expedientes por Estado -->
      <mat-card appearance="outlined" class="chart-card">
        <ngx-spinner [zIndex]="100" name="spCantidadPorEstado" bdColor="rgba(255,255,255,0.8)" size="default"
          color=" var(--primary-color)" type="ball-atom" [fullScreen]="false"></ngx-spinner>

        <mat-card-header class="card-header">
          <div class="header-content">
            <mat-icon class="header-icon">donut_large</mat-icon>
            <div class="header-text">
              <mat-card-title>Expedientes por Estado</mat-card-title>
              <mat-card-subtitle>Distribución de expedientes según su estado</mat-card-subtitle>
            </div>
          </div>
        </mat-card-header>

        <mat-divider></mat-divider>

        <mat-card-content class="chart-content">
          <!-- Gráfico de Estado -->
          <div class="chart-container" *ngIf="cantidadPorEstadoDto.length > 0">
            <canvas #chartEstado id="chart-estado" style="border: 1px solid #ddd; background: white;">
            </canvas>
          </div>

          <!-- Resumen Estado -->
          <div class="chart-summary" *ngIf="cantidadPorEstadoDto.length > 0">
            <div class="summary-item">
              <mat-icon>folder</mat-icon>
              <span class="summary-value">{{ calcularCantidadTotalExpedientePorEstado() }}</span>
              <span class="summary-label">expedientes totales</span>
            </div>
          </div>

          <!-- Sin datos Estado -->
          <div class="no-data" *ngIf="cantidadPorEstadoDto.length === 0">
            <mat-icon>analytics</mat-icon>
            <span>No hay datos de estado disponibles</span>
          </div>
        </mat-card-content>

        <mat-card-actions>
          <button mat-button [routerLink]="['/expedientes']">
            <mat-icon>list</mat-icon>
            Ver listado
          </button>
        </mat-card-actions>
      </mat-card>

    </div>
    <div class="col">

      <!-- Card Expedientes por Tipo -->
      <mat-card appearance="outlined" class="chart-card">
        <ngx-spinner [zIndex]="100" name="spCantidadPorTipo" bdColor="rgba(255,255,255,0.8)" size="default"
          color=" var(--primary-color)" type="ball-atom" [fullScreen]="false"></ngx-spinner>

        <mat-card-header class="card-header">
          <div class="header-content">
            <mat-icon class="header-icon">pie_chart</mat-icon>
            <div class="header-text">
              <mat-card-title>Expedientes por Tipo</mat-card-title>
              <mat-card-subtitle>Cantidad de expedientes por tipo de caso</mat-card-subtitle>
            </div>
          </div>
        </mat-card-header>

        <mat-divider></mat-divider>

        <mat-card-content class="chart-content">
          <!-- Gráfico de Tipo -->
          <div class="chart-container" *ngIf="cantidadPorTipoDto.length > 0">
            <canvas #chartTipo id="chart-tipo" style="border: 1px solid #ddd; background: white;">
            </canvas>
          </div>

          <!-- Resumen Tipo -->
          <div class="chart-summary" *ngIf="cantidadPorTipoDto.length > 0">
            <div class="summary-item">
              <mat-icon>category</mat-icon>
              <span class="summary-value">{{ calcularCantidadTotalPorTipo() }}</span>
              <span class="summary-label">expedientes por tipo</span>
            </div>
          </div>

          <!-- Sin datos Tipo -->
          <div class="no-data" *ngIf="cantidadPorTipoDto.length === 0">
            <mat-icon>analytics</mat-icon>
            <span>No hay datos de tipo disponibles</span>
          </div>
        </mat-card-content>

        <mat-card-actions>
          <button mat-button [routerLink]="['/expedientes']">
            <mat-icon>list</mat-icon>
            Ver listado
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

  </div>
</div>
